const InvoiceLoader = ({ title = 'Loading Invoice' }) => {
    return (
        <div id="invoice-loader" className="invoice-loader">
            <div className="inv-loader-card">

                {/* ── Spinner ring ── */}
                <div className="inv-loader-icon-wrap">
                    <svg className="inv-loader-svg" viewBox="0 0 64 64" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        {/* track */}
                        <circle cx="32" cy="32" r="26"
                            stroke="#e2e8f0" strokeWidth="4" />
                        {/* spinning arc */}
                        <circle className="inv-loader-spin" cx="32" cy="32" r="26"
                            stroke="url(#invGrad)" strokeWidth="4"
                            strokeLinecap="round"
                            strokeDasharray="80 83" />
                        <defs>
                            <linearGradient id="invGrad" x1="0" y1="0" x2="64" y2="64"
                                gradientUnits="userSpaceOnUse">
                                <stop offset="0%" stopColor="#6366f1" />
                                <stop offset="100%" stopColor="#2563eb" />
                            </linearGradient>
                        </defs>
                    </svg>

                    {/* document icon inside ring */}
                    <div className="inv-loader-inner-icon">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                            stroke="#2563eb" strokeWidth="1.8" strokeLinecap="round"
                            strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12
                a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                        </svg>
                    </div>
                </div>

                {/* ── Text ── */}
                <p className="inv-loader-title">{title}</p>
                <p className="inv-loader-sub">Please wait a moment…</p>

            </div>
        </div>
    );
};

export default InvoiceLoader;
